import React, { useContext } from "react";
import { ExtraFee } from "../../../../data/entities";
import FormType, { FieldConfigs } from "../../../../shared/components/FormType";
import { AuthenticationContext } from "../../../../provider/AuthenticationProvider";
import { ROLE } from "../../../../data/enums";

interface FormContainerProps {
    validated: boolean;
    extraFee: ExtraFee;
    mergeextraFee: Function;
}

const FormContainer = ({
                           validated,
                           extraFee,
                           mergeextraFee,
                       }: FormContainerProps) => {
    const {
        user: { role },
    } = useContext(AuthenticationContext);

    const fields: FieldConfigs[] = [
        {
            label: "Mã chi phí",
            type: "text",
            key: "extra_fee_code",
            required: true,
        },
        { label: "Tên chi phí", type: "text", key: "name", required: true },
        {
            label: "Giá",
            type: "text",
            key: "price",
            required: true,
            numeric: true,
        },
        {
            label: "Danh mục",
            type: "dropdown",
            key: "category",
            options: [
                { text: "Phuy", value: "Phuy" },
                { text: "Thùng", value: "Thùng" },
                { text: "Cơ Khí Ô Tô", value: "Cơ Khí Ô Tô" },
            ],
            required: true,
        },
    ];

    const getFields = () => {
        switch (role) {
            case ROLE.SALE_MANAGER:
            case ROLE.SALE_STAFF:
            case ROLE.STORAGE_KEEPER:
            case ROLE.FIRST_STORAGE_KEEPER:
            case ROLE.SECOND_STORAGE_KEEPER:
            case ROLE.DELIVERER:
                return fields.map((item) => ({ ...item, disabled: true }));
            case ROLE.LOGISTIC_MANAGER:
            case ROLE.LOGISTIC_STAFF:
            case ROLE.PURCHASING_STAFF:
            case ROLE.PRODUCTION_STAFF:
            case ROLE.MANAGER:
            case ROLE.ACCOUNTANT_MANAGER:
            case ROLE.FACTORY_STAFF:
            case ROLE.FACTORY_MANAGER_ONE:
            case ROLE.FACTORY_MANAGER_TWO:
            case ROLE.DEPUTY_FACTORY_MANAGER_ONE:
            case ROLE.DEPUTY_FACTORY_MANAGER_TWO:
                return fields;
            default:
                return fields;
        }
    };

    return (
        <FormType
            title={"Thông tin chi phí kèm theo"}
            fields={getFields()}
            validated={validated}
            requireData={{
                ...extraFee,
                extra_fee_code: extraFee.extra_fee_code,
                name: extraFee.name,
                price: extraFee.price,
                category: extraFee.category,
            }}
            mergeFormData={mergeextraFee}
        />
    );
};

export default FormContainer;
